import styled from "styled-components";

import { FLIGHT_TYPE_CF } from "../../../constants";

export const Wrapper = styled("div")(({ theme, flightType }) => ({
  display: "flex",
  gap: 13,
  width: flightType !== FLIGHT_TYPE_CF ? "auto" : 266,
  flex: flightType !== FLIGHT_TYPE_CF ? "1 1 37%" : "0 0 auto",
  minWidth: 0,
  position: "relative",

  [theme.down("xl")]: {
    width: flightType !== FLIGHT_TYPE_CF ? "auto" : 226,
  },

  [theme.down("lg")]: {
    width: flightType !== FLIGHT_TYPE_CF ? "auto" : 186,
  },

  [theme.down("md")]: {
    width: flightType !== FLIGHT_TYPE_CF ? "100%" : 188,
    flex: "0 0 auto",
  },

  [theme.down("sm")]: {
    display: "grid",
    gridTemplateColumns: flightType !== FLIGHT_TYPE_CF ? "1fr 1fr" : "1fr",
    width: "100%",
    gap: 10,
  },
}));

export const FromDateBlock = styled("div")(({ theme, flightType }) => ({
  backgroundColor: theme.palette.fly.inputBg,
  width: flightType !== FLIGHT_TYPE_CF ? "calc(50% - 6.5px)" : "100%",
  minWidth: 0,
  height: 60,
  position: "relative",
  cursor: "pointer",
  transition: "all .2s ease",
  border: "1px solid transparent",
  borderRadius: 6,

  "&:hover": {
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },

  [theme.down("md")]: {
    width: flightType !== FLIGHT_TYPE_CF ? 374.5 : "100%",
  },

  [theme.down("sm")]: {
    width: "100%",
  },

  "&.notFilled": {
    backgroundColor: "#f5d1d1",
    border: `1px solid ${theme.palette.error.main}`,
    transition: "background-color .3s ease",
  },
}));

export const ToDateBlock = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.fly.inputBg,
  width: "calc(50% - 6.5px)",
  minWidth: 0,
  height: 60,
  position: "relative",
  cursor: "pointer",
  transition: "all .2s ease",
  border: "1px solid transparent",
  borderRadius: 6,

  "&:hover": {
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },

  [theme.down("md")]: {
    width: 374.5,
  },

  [theme.down("sm")]: {
    width: "100%",
  },
}));

export const InputPlaceholder = styled("div")(({ theme }) => ({
  ...theme.paddings(20, 15, 0, 54),
  height: 60,
  width: "100%",
  position: "absolute",
  left: 0,
  top: 0,
  fontSize: 12,
  fontWeight: 500,
  transition: "all .2s ease",
  color: theme.palette.fly.placeholder,
  pointerEvents: "none",

  "&.not-empty": {
    ...theme.paddings(4, 15, 0, 50),
    fontSize: 11,
  },
}));

export const InputIconBlock = styled("span")(({ theme }) => ({
  display: "flex",
  position: "absolute",
  left: 25,
  top: 21,
  zIndex: 5,
  color: theme.palette.fly.placeholder,
  fontSize: 18,
}));

export const InputDate = styled("div")(({ theme }) => ({
  ...theme.paddings(20, 15, 0, 54),
  fontSize: 15,
  color: theme.palette.text.primary,
  fontWeight: 500,
}));

export const InputClearBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  padding: 5,
  gap: 5,
  position: "absolute",
  right: 15,
  top: "calc(50% - 14px)",
  backgroundColor: "transparent",

  "& > svg": {
    fontSize: 18,
    color: theme.palette.text.muted,
    cursor: "pointer",
    transition: "all .2s ease",

    "&:hover": {
      color: theme.palette.fly.brand,
      transform: "scale(1.1)",
    },
  },
}));
